exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status {\n  border: 1px solid;\n  border-radius: 4px;\n}\n\n.PendingConfirmation {\n  color: orange;\n  border-color: orange;\n}\n\n.Active {\n  color: green;\n  border-color: green;\n}\n\n.Inactive {\n  color: black;\n  border-color: black;\n}\n\n.Decline {\n  color: red;\n  border-color: red;\n}\n\n.New {\n  color: blue;\n  border-color: blue;\n}\n\nimg {\n  width: 70px;\n  margin-right: 0.5rem;\n  border-radius: 4px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/system-hotel-requests/system-hotel-requests.component.css
// module id = ../../../../../src/app/main/pages/system-hotel-requests/system-hotel-requests.component.css
// module chunks = main